import ArrowSvgIcon from '../../../assets/svg/arrow-back.svg?react';
import styles from './FJMobileHeaderLine.module.less';
const FJMobileHeaderLine = props => {
    const { gotoBackText, gotoBack, title } = props;
    return (
        <div className={styles.header}>
            <div className={styles.header_back} onClick={gotoBack}>
                <ArrowSvgIcon />
                {gotoBackText && <div className={styles.header_back_text}>{gotoBackText}</div>}
            </div>
            {title && <div className={styles.header_title}>{title}</div>}
        </div>
    );
};
export default FJMobileHeaderLine;
